import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const UPDATE_REQUEST = 'realhub/agencyDigitalTemplate/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'realhub/agencyDigitalTemplate/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'realhub/agencyDigitalTemplate/UPDATE_FAILURE'

// Initial State
const initialState = {
  updating: false,
  errors: [],
}

// Actions
export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function bulkUpdateIds(digitalTemplate, agencyIds, options){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      permissions: agencyIds,
    }),
  }

  return (dispatch, getState) => {
    // Set Loading
    dispatch(updateRequest())

    const promise = api(`/admin/digital_templates/${digitalTemplate.id}/update_permissions.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const state = getState()
        const updatedTemplate = { ...state.entities.digitalTemplates[digitalTemplate.id] }
        const permissionIds = updatedTemplate.permission_ids || {}
        permissionIds.agencies = json.map(agencyDigitalTemplate => agencyDigitalTemplate.agency_id)
        updatedTemplate.permission_ids = permissionIds

        const normalizedTemplatePage = normalize(updatedTemplate, Schemas.DIGITAL_TEMPLATE)
        dispatch(updateEntities(normalizedTemplatePage))
        dispatch(updateSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(updateFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case UPDATE_REQUEST:
      return { ...state, updating: true }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
